import { atom } from "recoil";

export const mappingAssetsToAlertState = atom<number>({
  key: "mappingAssetsToAlertState",
  default: 0,
});
